var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 43.0832C35.0457 43.0832 44 34.3154 44 23.4998C44 12.6843 35.0457 3.9165 24 3.9165C12.9543 3.9165 4 12.6843 4 23.4998C4 34.3154 12.9543 43.0832 24 43.0832Z",
    fill: "#39CCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.4998L21 29.3748L33 17.6248M44 23.4998C44 34.3154 35.0457 43.0832 24 43.0832C12.9543 43.0832 4 34.3154 4 23.4998C4 12.6843 12.9543 3.9165 24 3.9165C35.0457 3.9165 44 12.6843 44 23.4998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleCompleted);
export default __webpack_public_path__ + "static/media/check-circle-completed.94a2c1492b72eb79b7736a1b3a4e19e5.svg";
export { ForwardRef as ReactComponent };